import { render, staticRenderFns } from "./basicDataMgr.vue?vue&type=template&id=3dd828a5&scoped=true"
import script from "./basicDataMgr.vue?vue&type=script&lang=js"
export * from "./basicDataMgr.vue?vue&type=script&lang=js"
import style0 from "./basicDataMgr.vue?vue&type=style&index=0&id=3dd828a5&prod&lang=less&scoped=true"
import style1 from "./basicDataMgr.vue?vue&type=style&index=1&id=3dd828a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd828a5",
  null
  
)

export default component.exports